import useApiServices from './useApiServices';
import { globalAdminUrl } from './globalApi';
//
/**
 * @module AdminServiceService
 * @returns  it return All DataSource Apis
 */

const AgreementService = {
  // Bulk Upload the Prospect
  SaveBankInfo: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/save-bank-info`, credential, token),

  SaveBranchInfo: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/save-branch-info`, credential, token),

  AgreementList: (credential, token) =>
    useApiServices().agreementlistApi(`${globalAdminUrl}/agreement/list`, credential, token),

  SaveCommissionInfo: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/save-commission-info`, credential, token),

  UploadDocument: () => `${globalAdminUrl}/agreement/uploadDocument`,

  Edit: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/edit`, credential, token),

  Viewagreement: (credential, token) =>
    useApiServices().viewagreementpostApi(`${globalAdminUrl}/agreement/view`, credential, token),

  BankListAgreement: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/bank/list`, credential, token),

  DeleteBranchInfo: (credential, token) =>
    useApiServices().putApi(`${globalAdminUrl}/agreement/delete-branch-info`, credential, token),

  DeleteCommissionInfo: (credential, token) =>
    useApiServices().putApi(
      `${globalAdminUrl}/agreement/delete-commission-info`,
      credential,
      token
    ),

  CheckBranch: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/checkBranch`, credential, token),

  AgreementBankBranchList: (id, token) =>
    useApiServices().getApi(`${globalAdminUrl}/agreement/branch/${id}`, token),

  Terminate: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/terminate`, credential, token),

  LoanMasterList: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/company/all-loan-masters/list`, credential, token),

  ParentLoanMasters: (credential, token) =>
    useApiServices().postApi(
      `${globalAdminUrl}/company/parent-loan-masters/list`,
      credential,
      token
    ), // Loan types by Company

  SubLoanMasters: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/company/loan-masters/list`, credential, token), // Loan sub-types by Company

  ParentEmpTypeList: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/company/parent-emp-types/list`, credential, token), // Employment Types by Company

  SubEmpTypeList: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/company/emp-types/list`, credential, token), // Sub Employment Types by Company

  // agreement set-active finish button api
  AgreementSetActive: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/agreement/set-active`, credential, token),

  BankFilterDropdownList: (credential, token) =>
    useApiServices().postApi(
      `${globalAdminUrl}/agreement/bank-filter-dropdown/list`,
      credential,
      token
    )
};

export default AgreementService;
